import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { YELLOW_COLOR } from '../theme';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

interface props {
  onClick?: () => Promise<void>;
  leftPosition: boolean;
  border: boolean;
  backgroundColor: boolean;
  isFavourited: boolean;
  ariaLabel: string;
  disabled: boolean;
  smallStar: boolean;
  text?: string;
}

export const StarButton = ({
  onClick,
  leftPosition,
  border,
  backgroundColor,
  isFavourited,
  ariaLabel,
  disabled,
  smallStar,
  text,
}: props) => (
  <IconButton
    onClick={onClick}
    color='primary'
    sx={{
      position: 'absolute',
      top: 0,
      left: leftPosition && 0,
      right: !leftPosition && 0,
      border: border && `1px solid ${isFavourited ? 'white' : YELLOW_COLOR}`,
      borderRadius: border ? '50px' : undefined,
      marginTop: '10px',
      marginLeft: leftPosition ? '10px' : undefined,
      marginRight: !leftPosition ? '10px' : undefined,
      backgroundColor: backgroundColor && isFavourited ? YELLOW_COLOR : 'white',
      '&:hover': {
        backgroundColor: backgroundColor && isFavourited ? YELLOW_COLOR : 'white',
      },
      padding: text ? '5px 10px' : '8px',
      width: text ? 'auto' : '35px',
      height: text ? 'auto' : '35px',
      minWidth: text ? 'auto' : '35px',
    }}
    aria-label={ariaLabel}
    disabled={disabled}
  >
    <StarRoundedIcon
      sx={{ color: isFavourited ? 'white' : YELLOW_COLOR, fontSize: smallStar && '14px' }}
    />

    {text && (
      <Typography
        sx={{
          color: isFavourited ? 'white' : YELLOW_COLOR,
          fontSize: '12px',
          marginLeft: '2px',
        }}
      >
        {text}
      </Typography>
    )}
  </IconButton>
);
